import { useState, useMemo, useCallback } from 'react';
import { useGetRetailPendingApproveListQuery } from '../../../../api/endpoints/parts';

const useRetailPendingApproval = () => {
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null
    });

    const { data, isFetching, refetch } = useGetRetailPendingApproveListQuery({
        PageNumber: lazyParams.page,
        PageSize: lazyParams.rows
    });

    const items = data?.items ?? [];
    const totalCount = data?.totalCount ?? 0;

    const onPage = useCallback((event) => {
        const calculatedPage = Math.floor(event.first / event.rows) + 1;
        setLazyParams((prev) => ({
            ...prev,
            first: event.first,
            rows: event.rows,
            page: calculatedPage
        }));
    }, []);

    const onSort = useCallback((event) => {
        setLazyParams((prev) => ({
            ...prev,
            sortField: event.sortField,
            sortOrder: event.sortOrder
        }));
    }, []);

    const sortedData = useMemo(() => {
        if (!lazyParams.sortField) return items;
        const order = lazyParams.sortOrder === 1 ? 1 : -1;
        return [...items].sort((a, b) => {
            const aVal = a[lazyParams.sortField] ?? '';
            const bVal = b[lazyParams.sortField] ?? '';
            return order * String(aVal).localeCompare(String(bVal), 'tr', { numeric: true });
        });
    }, [items, lazyParams.sortField, lazyParams.sortOrder]);

    return {
        data: sortedData,
        totalCount,
        loading: isFetching,
        lazyParams,
        onPage,
        onSort,
        refetch
    };
};

export default useRetailPendingApproval;

